import { IThunkActionCreator } from '../../types/store';
import { ROAD_SAVED_FILTERS, SavedFiltersIds } from '../../interfaces/filters';
import { getRoadDistanceLabel, getRoadLabel } from '../../utils/filters_helpers';
import { addSavedFilter, justRemoveSavedFilter } from '../saved_filters/actions';
import { groupBy } from '../../utils/groupBy';
import { onFiltersChanged } from './actions';

export function changeRoadsSavedFilter(): IThunkActionCreator {
  return (dispatch, getState) => {
    const {
      filters: { road: roadFromFilter, roadDistance },
      roads: { currentRoads },
      savedFilters: { items },
    } = getState();
    const road = roadFromFilter || [];

    dispatch(onFiltersChanged(roadDistance, road));
    if (roadDistance) {
      dispatch(
        addSavedFilter({
          id: SavedFiltersIds.RoadDistance,
          name: getRoadDistanceLabel(roadDistance),
          value: roadDistance,
        }),
      );
    }

    items.forEach(value => ROAD_SAVED_FILTERS.includes(value.id) && dispatch(justRemoveSavedFilter(value)));

    // Группируем все части шоссейной дороги в массив этого шоссе, и всё укладываем в словарь с шоссейными дорогами
    const groupedRoads = groupBy(currentRoads, 'directionId');
    const directionIds = Object.keys(groupedRoads);

    directionIds.forEach((key: string) => {
      if (key === 'undefined') {
        return;
      }
      const directionParts = groupedRoads[key];

      const isDirectionChecked = directionParts.every(({ id }) => road.includes(id)) && key !== 'null';
      if (isDirectionChecked) {
        dispatch(
          addSavedFilter({
            id: SavedFiltersIds.GroupedRoad,
            name: directionParts[0].directionName,
            value: directionParts[0].directionId,
          }),
        );
      } else {
        directionParts.forEach(value => {
          if (road.includes(value.id)) {
            dispatch(
              addSavedFilter({
                id: SavedFiltersIds.Road,
                name: getRoadLabel(value),
                value: value.id,
              }),
            );
          }
        });
      }
    });
  };
}
